import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import { DataGridItem } from "components/data-grid";
import { FormattedMessage } from "react-intl";
import { BackButton } from "./back-button";
import Typography from "@material-ui/core/Typography";
import styles from "./styles/page-header-bar-static-content.css.js";

const PageHeaderBarStaticContent = ({
  buttons,
  showBackButton,
  backButtonUrl = null,
  classes,
  title,
  titleParams,
  subtitle,
}) => (
  <DataGridItem
    threeQuarter
    sizesOverride={!title ? { xl: 11, lg: 11, md: 11, sm: 11, xs: 11 } : {}}
    big={!buttons}
    className={classes.page_header_bar_static}
  >
    <div>{showBackButton && <BackButton url={backButtonUrl} />}</div>
    {title && (
      <div className={classes.page_header_bar_main_title_container}>
        <Typography
          className={classes.page_header_bar_main_title}
          variant={subtitle ? "h6" : "h4"}
          gutterBottom
          component="h1"
        >
          <FormattedMessage id={title} values={titleParams} />
        </Typography>
      </div>
    )}
  </DataGridItem>
);

PageHeaderBarStaticContent.propTypes = {
  /**
   * Elemento con el contenido de la botonera
   */
  buttons: PropTypes.element,
  /**
   * Indica si muestra el botón "atrás"
   */
  showBackButton: PropTypes.bool,
  /**
   * Utiliza estilos de subtítulo para el texto
   */
  subtitle: PropTypes.bool,
  /**
   * Título de la cabecera
   */
  title: PropTypes.string,
  /**
   * Url concreta a la que se quiere ir (opcional)
   */
  backButtonUrl: PropTypes.string,
  /**
   * Parámetros del título de la cabecera
   */
  titleParams: PropTypes.object,
};

export default withStyles(styles)(PageHeaderBarStaticContent);
